module.exports = require("core-js/library/fn/number/min-safe-integer");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/number/min-safe-integer.js
// module id = 148
// module chunks = 35783957827783 70144966829960 114276838955818 198517197184460